module.exports = __webpack_public_path__ + "static/media/avatar.f12e9014.jpg";